import { takeEvery, takeLatest } from 'redux-saga/effects';
import { PROVIDER_MODULE } from '../../../configs/moduleNames';
import {
  LOAD_PROVIDER_LIST,
  CREATE_PROVIDER,
  DELETE_PROVIDER,
  EDIT_PROVIDER_BY_ID,
  LOAD_PROVIDER_BY_ID,
} from '../actions';

import loadProviderList from './loadProviderList';
import createProvider from './createProvider';
import loadProviderById from './loadProviderById';
import editProviderById from './editProviderById';
import deleteProvider from './deleteProvider';

export default function* watchDashboard() {
  yield takeLatest(PROVIDER_MODULE + LOAD_PROVIDER_LIST, loadProviderList);
  yield takeLatest(PROVIDER_MODULE + CREATE_PROVIDER, createProvider);
  yield takeEvery(PROVIDER_MODULE + LOAD_PROVIDER_BY_ID, loadProviderById);
  yield takeEvery(PROVIDER_MODULE + EDIT_PROVIDER_BY_ID, editProviderById);
  yield takeEvery(PROVIDER_MODULE + DELETE_PROVIDER, deleteProvider);
}
